import { fetchSessionItems } from "./mutations";

// Shared cache: useResumeSession primes it on COMPLETE; the report hydrator
// reuses it. Session items are immutable, so staleTime is safe and makes report
// back/forward navigation free.
export const SESSION_ITEMS_STALE_TIME = 5 * 60 * 1000;

export const sessionItemsQueryOptions = (sessionId: number) => ({
	queryKey: ["session-items", sessionId] as const,
	queryFn: () => fetchSessionItems({ sessionId }),
	staleTime: SESSION_ITEMS_STALE_TIME,
});
